import { api } from './api';

export type PrintUnits = 'mm' | 'in';
export type PrintFormat = 'png' | 'jpg';
export type PrintFitMode = 'contain' | 'cover';
export type PrintBackgroundMode = 'preserve' | 'fill-white' | 'fill-custom';

export interface PrintPackageRequest {
  mockupId: string;
  format: PrintFormat;
  units: PrintUnits;
  width: number;
  height: number;
  dpi: number;
  bleed: number;
  safeMargin: number;
  fitMode: PrintFitMode;
  backgroundMode: PrintBackgroundMode;
  backgroundColor?: string;
}

const triggerDownload = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const slugify = (value: string) => (
  value
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    || 'mockup'
);

class PrintPrepService {
  async exportPackage(mockupName: string, request: PrintPackageRequest): Promise<void> {
    const response = await api.post('/api/download/print-package', request, {
      responseType: 'blob',
    });

    const packageName = `${slugify(mockupName)}-print-package.zip`;
    triggerDownload(new Blob([response.data], { type: 'application/zip' }), packageName);
  }
}

export const printPrepService = new PrintPrepService();
